import usePDPContext from './usePDPContext';

const usePdpSlug = () => usePDPContext()?.slug ?? null;

export default usePdpSlug;
